// Component Imports
import {
  ESignApprovalBtn,
  ESignBtn,
  InviteTeamMemberBtn,
  ReferralBtn,
  WorkflowApprovalBtn,
} from "../Buttons";

// Constant Imports
import { DOCUMENT_STAGES, DOCUMENT_ROLES } from "../Constants";

// eslint-disable-next-line import/prefer-default-export
export const DOCUMENT_BTNS = {
  [DOCUMENT_STAGES.DRAFT]: {
    [DOCUMENT_ROLES.ADMIN]: [
      { name: "referral", component: ReferralBtn },
      { name: "inviteTeamMember", component: InviteTeamMemberBtn },
      { name: "eSign", component: ESignBtn },
    ],
    [DOCUMENT_ROLES.USER]: [
      // Download Btn comes here
    ],
  },
  [DOCUMENT_STAGES.INTERNAL_REVIEW]: {
    [DOCUMENT_ROLES.ADMIN]: [
      { name: "referral", component: ReferralBtn },
      { name: "inviteTeamMember", component: InviteTeamMemberBtn },
      {
        name: "eSign",
        component: ESignBtn,
        props: {
          disabled: true,
          disabledMsg: "Please get document approved to send it for eSign.",
        },
      },
      { name: "workflowApproval", component: WorkflowApprovalBtn },
    ],
    [DOCUMENT_ROLES.USER]: [
      { name: "workflowApproval", component: WorkflowApprovalBtn },
    ],
  },
  [DOCUMENT_STAGES.SENT_FOR_FILLING]: {
    [DOCUMENT_ROLES.ADMIN]: [
      { name: "referral", component: ReferralBtn },
      { name: "inviteTeamMember", component: InviteTeamMemberBtn },
    ],
    [DOCUMENT_ROLES.USER]: [
      // Download btn cmes here
    ],
  },
  [DOCUMENT_STAGES.APPROVED]: {
    [DOCUMENT_ROLES.ADMIN]: [
      { name: "referral", component: ReferralBtn },
      { name: "inviteTeamMember", component: InviteTeamMemberBtn },
      {
        name: "eSign",
        component: ESignBtn,
      },
    ],
    [DOCUMENT_ROLES.USER]: [
      // Download Btn comes here
    ],
  },
  [DOCUMENT_STAGES.SENT]: {
    [DOCUMENT_ROLES.ADMIN]: [
      { name: "referral", component: ReferralBtn },
      { name: "inviteTeamMember", component: InviteTeamMemberBtn },
      {
        name: "eSign",
        component: ESignBtn,
        props: {
          disabled: true,
          disabledMsg: "Document already sent for signature/acceptance.",
        },
      },
      { name: "eSignApproval", component: ESignApprovalBtn },
    ],
    [DOCUMENT_ROLES.USER]: [
      { name: "eSignApproval", component: ESignApprovalBtn },
    ],
  },
  [DOCUMENT_STAGES.SENT_FOR_FILLING]: {
    [DOCUMENT_ROLES.ADMIN]: [
      { name: "referral", component: ReferralBtn },
      { name: "inviteTeamMember", component: InviteTeamMemberBtn },
      {
        name: "eSign",
        component: ESignBtn,
        props: {
          disabled: true,
          disabledMsg: "Document already sent for signature/acceptance.",
        },
      },
      // { name: "eSignApproval", component: ESignApprovalBtn },
    ],
    [DOCUMENT_ROLES.USER]: [
      { name: "eSignApproval", component: ESignApprovalBtn },
    ],
  },

  [DOCUMENT_STAGES.DECLINED]: {
    [DOCUMENT_ROLES.ADMIN]: [
      { name: "referral", component: ReferralBtn },
      { name: "inviteTeamMember", component: InviteTeamMemberBtn },
      {
        name: "eSign",
        component: ESignBtn,
        props: {
          disabled: true,
          disabledMsg:
            "Cannot eSign documents that have been declined or rejected.",
        },
      },
    ],
    [DOCUMENT_ROLES.USER]: [],
  },
  [DOCUMENT_STAGES.COMPLETED]: {
    [DOCUMENT_ROLES.ADMIN]: [
      { name: "referral", component: ReferralBtn },
      { name: "inviteTeamMember", component: InviteTeamMemberBtn },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Configuration/Components.js